import { Card, Typography, Box, IconButton ,Button} from "@mui/material";
import React, { useState, useEffect ,useRef } from "react";
import { useReactToPrint } from "react-to-print";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";

const baseUrl=process.env.REACT_APP_API_BASE_URL
const TransferCertificate = () => {
  const navigate = useNavigate();
  const componentRef = useRef();
  const {oId,board,pId}=useAuth();
  const { tcId } = useParams();

  // const [studentDetails, setStudentDetails] = useState([]);
  // console.log('i am studentdetails '+ studentDetails)
  const [studentDetails, setStudentDetails] = useState(null); // Change to null for object

  console.log("Student Details:", studentDetails);


  useEffect(() => {
    if (!tcId || !oId) {
      console.warn("TCID or OID is null or undefined.");
      return;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/studentTransfer/getAllByTcId/${tcId}/${oId}/${pId}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        // Check if data is an array and has at least one element
        if (Array.isArray(data) && data.length > 0) {
          setStudentDetails(data[0]); // Store the first object from array
        } else {
          console.warn("Received empty or unexpected data format.");
          setStudentDetails(null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [tcId, oId]);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Transfer Certificate",
  });


  const data = [
    { col1: "1. Name of the Pupil", col2: `${studentDetails?.surName || ""} ${studentDetails?.firstName || ""} ${studentDetails?.lastName || ""}` },
    { col1: "2. Father's Name", col2: `${studentDetails?.fathersFirstName || ""} ${studentDetails?.fathersLastName || ""}` },
    { col1: "3. Mother's Name", col2: `${studentDetails?.mothersFirstName || ""} ${studentDetails?.mothersLastName || ""}` },
    { col1: "4. Date of Birth as entered in the Admission Register", col2: studentDetails?.dob || "N/A" },
    { col1: "5. Nationality", col2: studentDetails?.nationality || "N/A" },
    { col1: "6. Religion", col2: studentDetails?.religion || "N/A" },
    { col1: "7. Whether the candidate belongs to SC/ST/OBC", col2: studentDetails?.caste || "N/A" },
    { col1: "8. Class in which pupil last studied", col2: `${studentDetails?.romanNumberClass || "N/A"}` },
    ...(board === "INTERMEDIATE"
      ? [{ col1: "8A. Course", col2: `${studentDetails?.course || "N/A"}` }]
      : []),
    { col1: "9. Date of first admission in the school", col2: studentDetails?.admissionDate || "N/A" },
    { col1: "10. Whether qualified for promotion", col2: "Yes" },
    { col1: "11. Whether all school dues are cleared", col2: "Yes" },
    // { col1: "12. Total working days in the academic session", col2: "220" },
    // { col1: "13. Total working days present", col2: "210" },
    { col1: "14. Identification Mark 1", col2: studentDetails?.mole1 || "N/A" },
    { col1: "15. Identification Mark 2", col2: studentDetails?.mole2 || "N/A" },
    { col1: "16. General Conduct", col2: "Good" },
    { col1: "17. Reason for leaving the school", col2: studentDetails?.reasonForTransfer || "Relocation" },
  ];
  
  
  
  
  return (
    <Card
      style={{
        // height: "100vh",
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "white",
        margin: "6% 1% 2% 1%",
        width: "calc(100% - 1.8%)",
        padding: "31px 30px 30px 30px",
        // overflow: "auto",
      }}
    >
      
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: 2 }}>
            {/* Left-aligned section */}
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                <KeyboardBackspaceIcon fontSize="medium" />
              </IconButton>
              <Typography variant="h4" component="h3" sx={{ fontWeight: "bold", marginLeft: 0 }}>
                TRANSFER CERTIFICATE
              </Typography>
            </Box>

            {/* Right-aligned button */}
           
            <Button
  variant="contained" // Filled button
  sx={{
    backgroundColor: "#3C3972",
    color: "white",
    fontSize: "0.75rem", // Adjusts text size
    padding: "4px 12px", // Proper padding
    minWidth: "80px", // Ensures button is wide enough
    height: "30px", // Adjusts height
    textTransform: "none", // Keeps text as normal (no uppercase)
    borderRadius: "4px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#3C3972",
    },
  }}
  onClick={handlePrint}
>
  PRINT
</Button>
          </Box>
          

      <div ref={componentRef} className="Tc-container" style={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      {/* <style>
        {`
            @media print {
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                background-color: #F9F6DC !important; 
              }
              #TransferCertificate {
                box-shadow: none !important; 
                border: 2.5px solid black !important;
                padding: 20px !important;
              }
              table {
                width: 100% !important;
                border-collapse: collapse !important;
                text-align: left !important;
              }
              td {
                border: 2px solid black !important;
                padding: 8px !important;
                font-weight: normal !important;
              }
              td:first-child {
                font-weight: bold !important; 
              }
              button {
                display: none !important; 
              }
            }
              `}
        </style> */}

        
        <div
         

          // id="TransferCertificate"
          // style={{
          //   padding: "20px",
          //   boxShadow: "inset 0 0 0 2.5px black",
          //   backgroundColor: "#F9F6DC",
          //   minHeight: "100vh", // Ensure it covers the full page
          //   paddingBottom: "0px", // Reduce extra spacing
          // }}

          id="TransferCertificate"
            style={{
              padding: "20px",
              boxShadow: "inset 0 0 0 2.5px black",
              backgroundColor: "#F9F6DC",
              flexGrow: 1, // Ensures the certificate takes up all available space
            }}
        >
          <div style={{ display: "flex", alignItems: "center", position: "relative", marginTop: "2px" }}>
            {/* <img
              src="assets/school logo.png"
              alt="School Logo"
              style={{
                width: "60px",
                position: "absolute",
                left: "0",
              }}
            /> */}
            <h1 style={{ margin: "0 auto", textAlign: "center" }}>{studentDetails?.schoolName || "Add school Name"}</h1>
          </div>

          <div style={{ display: "flex", flexDirection: "column", textAlign: "center" ,marginBottom:'20px'}}>
            <Typography>{studentDetails?.schoolAddress || "Add school Address"}</Typography>
            {/* <Typography>Recognized by Govt of A.P.R.C</Typography> */}
          </div>
          <Typography sx={{textAlign:'center',marginBottom:'20px'}}><strong style={{ fontSize: "20px" }}>TRANSFER CERTIFICATE</strong></Typography>

          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "0 20px" ,marginBottom:'20px'}}>
              <p style={{ margin: 0 }}>
                <strong>Admission No:</strong> {studentDetails?.generatedAdmissionNumber || ""}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Tc No:</strong> {studentDetails?.tcId || ""}
              </p>
          </div>


          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", border: "2px solid" }}>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "2px solid", padding: "8px", fontWeight: "bold" }}>{row.col1}</td>
                  <td style={{ border: "2px solid", padding: "8px", fontWeight: "normal" }}>{row.col2}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "auto", paddingBottom: "0px" ,marginTop:'100px'}}>
            <div>
              {/* <img src="assets/school p logo.png" alt="Teacher Signature" style={{ width: "80%", height: "40px" }} /> */}
              <Typography variant="h6" gutterBottom style={{ fontWeight: "bold" }}>
                Signature of Teacher
              </Typography>
            </div>
            <div>
              {/* <img src="assets/school p logo.png" alt="Checked By" style={{ width: "80%", height: "40px" }} /> */}
              <Typography variant="h6" gutterBottom style={{ fontWeight: "bold" }}>
                <span style={{ paddingLeft: "60px" }}>Checked by</span>
                <br />
                (with full name and designation)
              </Typography>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {/* <img src="assets/stamp.png" alt="Stamp" style={{ width: "80%", height: "40px" }} />
              <img src="assets/school p logo.png" alt="Principal Signature" style={{ width: "80%", height: "40px" }} /> */}
              <Typography variant="h6" gutterBottom style={{ fontWeight: "bold" }}>
                Signature of Principal
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TransferCertificate;
